<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Time Off Types</p>
      </div>

      <div class="flex justify-between items-center pl-0 ml-0 p-2">
        <div class="flex justify-between items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>
        <div class="flex flex-wrap justify-end w-full gap-3">
          <button
            @click="showCreateLeaveType = true"
            class="bg-primary gap-1 flex text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>
        </div>
      </div>

      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="tableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Leave Types found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateLeaveType
      @close="handleClose"
      :showCreateLeaveType="showCreateLeaveType"
      @closeOnSuccess="handleCloseOnSuccess"
      :isSubmitted="isSubmitted"
    ></CreateLeaveType>

    <!-- edit -->
    <EditLeaveType
      @close="handleClose"
      :leaveTypeToEdit="leaveTypeToEdit"
      :info="info"
      :showEditLeaveType="showEditLeaveType"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </EditLeaveType>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import axios from "axios";
import CreateLeaveType from "@/components/CompanySetups/leaveTypes/create.vue";
import EditLeaveType from "@/components/CompanySetups/leaveTypes/editLeaveType.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import { mapGetters } from "vuex";
import { utils, writeFileXLSX } from "xlsx";
// import Switches from 'vue-switches';
import VeCheckbox from "vue-easytable/libs/ve-checkbox";
export default {
  name: "leaveTypeList",
  components: { Loader, CreateLeaveType, EditLeaveType, ActionWarning },
  data() {
    return {
      showCreateLeaveType: false,
      showEditLeaveType: false,
      loading: false,
      get_error: null,
      create_success: "Leave Type created successfully",
      del_loca: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      leaveTypeToDelete: null,
      showWarning: false,
      leaveTypeToEdit: {},
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Name",
          key: "a",
          title: "Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "NumberOfDays",
          key: "b",
          title: "Number of days",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "PolicyDays",
          key: "g",
          title: "Policy Days",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "EarnedPerMonth",
          key: "earned",
          title: "Eearned",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) =>
            row.EarnedPerMonth == 0 ? "......" : row.EarnedPerMonth,
        },
        {
          field: "IncludeSaturday",
          key: "c",
          title: "Includes Saturdays",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.IncludeSaturday}></VeCheckbox>
          ),
          // row.IncludeSaturday ? <p>Yes</p> : <p>No</p>
        },

        {
          field: "Consecutive",
          key: "f",
          title: "Consecutive",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.Consecutive}></VeCheckbox>
          ),
        },
        {
          field: "ApplyBeforeToday",
          key: "ApplyBeforeToday",
          title: "Apply Before Today",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.ApplyBeforeToday}></VeCheckbox>
          ),
        },
        // HandoverNotesRequired
        {
          field: "HandoverNotesRequired",
          key: "HandoverNotesRequired",
          title: "Handover Notes",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.HandoverNotesRequired}></VeCheckbox>
          ),
        },
        {
          field: "OpenJanuary",
          key: "OpenJanuary",
          title: "Open January",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.OpenJanuary}></VeCheckbox>
          ),
        },

        {
          field: "CloseDecember",
          key: "CloseDecember",
          title: "Close December",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.CloseDecember}></VeCheckbox>
          ),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getLeaveTypes();
    this.setPageSizes();
  },
  methods: {
    isSubmitted() {
      this.showRequestLeave = false;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleClose() {
      this.showCreateLeaveType = false;
      this.showEditLeaveType = false;
    },
    handleCloseOnSuccess() {
      this.showCreateLeaveType = false;
      this.showLocCrSuccess = false;
      this.showEditLeaveType = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getLeaveTypes();
    },

    reload() {
      this.getDepartments();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteLeaveType(this.leaveTypeToDelete);
    },

    handleEditButtonClick(leave) {
      // Handle the button click for the edit button
      //console.log(leave);
      this.leaveTypeToEdit = {
        LeaveId: leave.Id,
        Name: leave.Name,
        Country: leave.Country,
        ...leave,
      };
      this.showEditLeaveType = true;
    },
    handleDeleteButtonClick(leaveType) {
      // Handle the button click for the delete button
      //console.log(leaveType)
      this.title = `Delete ${leaveType.Name}`;
      this.message = `You are about to delete ${leaveType.Name}!`;
      this.leaveTypeToDelete = leaveType;
      this.showWarning = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
      this.getLeaveTypes();
    },
    getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data.map((row) => {
                return { ...row, showActions: false };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    deleteLeaveType(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: { LeaveTypeId: row.Id },
      };

      axios
        .delete(`${this.getOrganization}/setup/leavetype/v1/delete`, options)
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.handleDeleteOnSuccess();
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },

    editLeaveType(row) {
      this.showEditLeaveType = true;
      this.info = row;
    },

    exportTemplate() {
      const ws = utils.json_to_sheet(this.tableData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");

      writeFileXLSX(wb, "leavetypes.xlsx");
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 30px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
}
</style>
